import Header from "./Header";
import Footer from "./Footer";

function Project() {
  return (
    <>
      <Header />

      <div className="project-page">
        <div className="project-container">

          {/* Breadcrumb */}
          <div className="project-breadcrumb">
            <a href="/">Homepage</a>
            <span>/</span>
            <a href="/portfolio">Portfolio</a>
            <span>/</span>
            <span>Project</span>
          </div>

          {/* Title */}
          <div className="project-title-section">
            <h1>
              Interior Design <span>Studio</span>
            </h1>
          </div>

          {/* Read More */}
          <div className="project-readmore">
            <span>Read more</span>

            <a href="#project-content" className="project-arrow">
              ↓
            </a>
          </div>

          {/* Main Layout */}
          <div className="project-layout" id="project-content">

            {/* Left Side */}
            <div className="project-sidebar">

              <div className="project-info-item">
                <p>Client: Envato Market</p>
              </div>

              <div className="project-info-item">
                <p>Date: April 2023</p>
              </div>

              <div className="project-info-item">
                <p>Author: Paul Trueman</p>
              </div>

              <div className="project-description">

                <h4>Simplicity, elegance, innovation!</h4>

                <p>
                  A home surveillance camera that pays great attention to
                  security and user privacy, featuring two modes to provide
                  security while protecting personal privacy.
                </p>

                <p>
                  Presents a simple and quiet state when not in use,
                  delivering a gentle and secure experience. The camera
                  can adapt to a variety of environments while maintaining
                  a modern visual identity.
                </p>

              </div>

            </div>

            {/* Right Side */}
            <div className="project-content">

              <div className="project-placeholder">
                Project Image Coming Soon
              </div>

              <div className="project-placeholder">
                Project Image Coming Soon
              </div>

              <div className="project-placeholder">
                Project Image Coming Soon
              </div>

            </div>

          </div>

          {/* Bottom Navigation */}
          <div className="project-nav">
            <a href="/portfolio">← Back to Portfolio</a>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
}

export default Project;